<template>
  <div>
    <b-button variant="outline-light" v-on:click="deleteCekiList()">
      <Icon icon="material-symbols:delete-outline" width="25" height="25" v-b-tooltip.hover.bottom="'SİL'" color="#EA5455" />
    </b-button>

  </div>
</template>


<script>
import { Icon } from "@iconify/vue2";
export default {
  components: { Icon },
  methods: {
    deleteCekiList() {
      this.$root.$emit("deleteCekiList", this.params.data);
    }
  }
}
</script>